import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { nafColor } from '@nafcore/theme';
import { breakpoints, spacing } from '@naf/theme';

export const Overlay = styled.div<{ $isMenuOpen?: boolean; $isSearchOpen?: boolean }>`
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease-in-out;
  pointer-events: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(6 46 42 / 50%);
  z-index: ${({ $isSearchOpen }) => ($isSearchOpen ? 95 : 80)};

  ${({ $isMenuOpen, $isSearchOpen }) =>
    ($isMenuOpen || $isSearchOpen) &&
    css`
      opacity: 1;
      visibility: visible;
      pointer-events: auto;
    `};

  @media (max-width: ${breakpoints.s}) {
    ${({ $isSearchOpen }) =>
      !$isSearchOpen &&
      css`
        display: none !important;
      `}
  }
`;

export const DecorationWrapper = styled.div<{ $isMenuOpen?: boolean }>`
  position: absolute;
  display: flex;
  z-index: 100;
  pointer-events: none;

  @media (max-width: ${breakpoints.l}) {
    ${({ $isMenuOpen }) =>
      $isMenuOpen &&
      css`
        display: none;
      `}
  }
`;

export const Wrapper = styled.div<{ $isMenuOpen?: boolean; $isSearchOpen?: boolean }>`
  display: flex;
  justify-content: center;
  height: 0;
  position: sticky;
  top: 0;
  z-index: 90;
  width: 100%;
  left: 0;
  right: 0;
  margin: 0;
  box-sizing: border-box;
  padding: 0 ${spacing.space16};

  a {
    text-decoration: none;
  }

  @media (max-width: ${breakpoints.l}) {
    background-color: ${({ $isMenuOpen }) => {
      if ($isMenuOpen) {
        return nafColor?.signature.yellow10 || '#FFFAEC';
      }
      return 'transparent';
    }};
  }

  * {
    box-sizing: content-box;
  }
`;

export const Container = styled.div<{ $isSearchOpen: boolean; $isMenuOpen: boolean }>`
  background-color: transparent;
  max-width: 1400px;
  box-sizing: border-box;
  width: 100%;
  position: sticky;

  @media (max-width: ${breakpoints.l}) {
    max-width: 100%;
  }

  @media (max-width: ${breakpoints.m}) {
    ${({ $isMenuOpen }) =>
      $isMenuOpen &&
      css`
        position: absolute;
      `}
    background-color: ${({ $isMenuOpen }) => {
      if ($isMenuOpen) {
        return nafColor?.signature.yellow10 || '#FFFAEC';
      }
      return 'transparent';
    }};
  }
`;
